<template>
	<header class="main-header-non-login sticky top-0 z-[998] bg-body dark:bg-dark-body">
		<a href="#main" class="skip-link">Sari la conținut</a>
		<Container class="px-2 py-2.5 lg:px-0">
			<div class="flex gap-base-2 justify-between items-center">
				<div class="flex items-center gap-2">
					<Logo :className="'max-h-8'"/>
				</div>
				<div class="flex gap-base-2">
					<BaseButton type="outlined" :to="{name: 'login'}">{{$t('Login')}}</BaseButton>
					<BaseButton type="outlined" v-if="this.config.signupEnable" :to="{name: 'signup'}">{{$t('Sign up')}}</BaseButton>
				</div>
			</div>
		</Container>
	</header>
</template>

<script>
import Container from '@/components/article/Container.vue';
import Logo from '../utilities/Logo.vue';
import BaseButton from '@/components/inputs/BaseButton.vue'
import { mapState } from 'pinia';
import { useAppStore } from '../../store/app';

export default {
	components: {
		Container, Logo, BaseButton
	},
	computed:{
		...mapState(useAppStore, ['config'])
	}
}
</script>
